export const ADMIN_AUTH_COOKIE_NAME = "sb-admin-auth-token";
export const PRO_AUTH_COOKIE_NAME = "sb-pro-auth-token";

export function getAuthCookieDomain(host?: string | null): string | undefined {
  const explicit = process.env.NEXT_PUBLIC_AUTH_COOKIE_DOMAIN;

  const usableExplicit =
    explicit && explicit.includes(".") && explicit !== ".localhost"
      ? explicit
      : undefined;

  let domain: string | undefined;
  if (usableExplicit) {
    domain = usableExplicit;
  } else if (process.env.NODE_ENV === "production") {
    const hostname = (host ?? "").toLowerCase().split(":")[0] ?? "";
    if (hostname === "interstud.co" || hostname.endsWith(".interstud.co")) {
      domain = ".interstud.co";
    }
  }

  return domain;
}

export function getAuthCookieName(host?: string | null): string {
  const hostname = (host ?? "").toLowerCase().split(":")[0] ?? "";
  if (hostname === "pro" || hostname.startsWith("pro.")) {
    return PRO_AUTH_COOKIE_NAME;
  }
  return ADMIN_AUTH_COOKIE_NAME;
}

export function getLegacyAuthCookieName(): string | null {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  if (!url) return null;
  try {
    const ref = new URL(url).hostname.split(".")[0];
    return ref ? `sb-${ref}-auth-token` : null;
  } catch {
    return null;
  }
}
